export class SurveyTopic {

  id?: string;
  nameTranslationKey?: string;
  private translationKeys = {};

  constructor(values: any = {}) {
    this.translationKeys['/api/internal_members'] = 'SATISFACTION.TOPIC.TRAINER';
    this.translationKeys['/api/external_members'] = 'SATISFACTION.TOPIC.TRAINER';
    this.translationKeys['/api/buildings'] = 'SATISFACTION.TOPIC.BUILDING';
    this.translationKeys['/api/room_bookings'] = 'SATISFACTION.TOPIC.ROOMBOOKING';
    this.translationKeys['/api/course_instances'] = 'SATISFACTION.TOPIC.COURSEINSTANCE';

    Object.assign(this, values);
    this.nameTranslationKey = this.translationKeys[this.id];
  }

}
